<template>
<div>
  <v-tooltip
    bottom>
    <template
      v-slot:activator="{ on, attrs }">

      <v-btn
        icon
        color="primary"
        v-bind="attrs"
        v-on="on"
        dark
        elevation="0"
        @click="onDialogButtonClick"
        small>

        <v-icon>{{icon}}</v-icon>

      </v-btn>

    </template>

    <!-- RAW形式で文字列展開 -->
    <span v-html="message"></span>

    <th-kamotsu-himoduke-nippo-search-dialog
      :showDialog="showDialog"
      @close="onDialogClosed"/>
  </v-tooltip>
</div>
</template>
<script>
const ThKamotsuHimodukeNippoSearchDialog = () => import('@/components/ThKamotsuHimodukeNippoSearchDialog')

export default {
  name: 'ThKamotsuHimodukeNippoSearchButton',
  components: {
    ThKamotsuHimodukeNippoSearchDialog
  },
  props: {
    message: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    innerValue: '',
    showDialog: false
  }),
  created () {
    this.innerValue = this.value
  },
  mounted () {
  },
  computed: {
    computedProps () {
      return {
        ...this.$props
        // readonly: this.readonly
      }
    },
    computedListeners () {
      return {
        ...this.$listeners
      }
    },
    isHelpDisplay () {
      return this.readonly === false
    }
  },
  methods: {
    onDialogButtonClick: function (e) {
      this.showDialog = true
      console.log('dialog opend', e)
    },
    onDialogClosed: function (e) {
      console.log('dialog closed', e, this.showDialog)
      this.showDialog = false
      if (e === undefined) { return }
      this.kamotsuHimodukeNippoSearchSync(e)
      /**
       * dialog選択値inputイベント
       * @event input
       * @type {Event}
       * this.$emit('input', this.innerValue)
       */
    },
    kamotsuHimodukeNippoSearchSync: function (e) {
      console.log(' **** XXXXX **** kamotsuHimodukeNippoSearchSync', e, this.showDialog)
      this.$emit('kamotsuHimodukeNippoSearchSync', e)
    }
  }
}
</script>
<style scoped>

</style>
